import React, { useState } from 'react';
import { ArrowRight, Check, ChevronRight, Facebook, Fence, Leaf, MapPin, Menu, Phone, Quote, Star, X } from 'lucide-react';
import { Card, CardContent } from '../components/Card';
import { EstimateForm } from '../components/EstimateForm';
const phoneHref = 'tel:+14303186275';
const mapUrl = 'https://maps.app.goo.gl/1kbELopTJhyu9bQ56';
const facebookUrl = 'https://www.facebook.com/profile.php?id=61578436612146';
const projects = [{
  src: 'https://cdn.magicpatterns.com/uploads/i2c8hMLmn3yaYwGdzZWUhv/archetex3.jpg',
  label: 'Custom fencing',
  className: 'md:col-span-2 md:row-span-2'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/nU2x1vp3ZSjSSkHQx8WP4d/archetex4.jpg',
  label: 'Automatic gates',
  className: ''
}, {
  src: 'https://cdn.magicpatterns.com/uploads/5aSNGLDgTDfreuvgUNdg5v/archetex2.jpg',
  label: 'Covered patios',
  className: ''
}, {
  src: 'https://cdn.magicpatterns.com/uploads/4eaAgYJr769TFJA9ctCDvi/archetex5.jpg',
  label: 'Decks & stairs',
  className: ''
}, {
  src: 'https://cdn.magicpatterns.com/uploads/gfXUxbCZ7VS4YsE6MqoGFC/archetex1.jpg',
  label: 'Landscape enhancement',
  className: ''
}];
const services = [{
  title: 'Fencing & Gates',
  description: 'Custom fencing and gates designed around the way you use your property.',
  image: projects[0].src,
  icon: Fence
}, {
  title: 'Decks & Outdoor Structures',
  description: 'Purpose-built decks, steps, and structures that extend your outdoor space.',
  image: projects[3].src,
  icon: ChevronRight
}, {
  title: 'Covered Patios & Outdoor Living',
  description: 'Outdoor living areas made for gathering, relaxing, and enjoying more time outside.',
  image: projects[2].src,
  icon: Check
}, {
  title: 'Landscape Design & Enhancement',
  description: 'Thoughtful landscape improvements that bring shape, texture, and finish to your home.',
  image: projects[4].src,
  icon: Leaf
}];
const additionalServices = ['Wood Privacy Fencing', 'Automatic Gates', 'Ornamental & Custom Gates', 'Pergolas', 'Arbors', 'Custom Decks', 'Patios & Outdoor Living', 'Landscape Design & Management', 'Pool Landscaping', 'Retaining Walls', 'Hardscaping', 'Concrete & Masonry', 'Drainage & Grading', 'Outdoor Step Construction'];
const reviews = [{
  name: 'Brandon Burns',
  text: 'Thank you so much Archetex Outdoor Design Co.!! Your entire team has been incredible to collaborate with! Thank you for all the creativity during the design process of our project! Yalll completely transformed our backyard into such a unique and amazing space for us to enjoy entertaining our closest friends & family for many years to come!! ...We 100% recommend your company to everyone!'
}, {
  name: 'Jacqueline Larey',
  text: 'He built a porch/deck for me at my camper and I love it!!! He is professional, courteous and meticulous!! Rock solid build!!!!'
}, {
  name: 'Vikki Bruce',
  text: 'Very knowledgeable, when the job is complete, you will definitely be glad you chose them. Reasonable prices and flawless work.'
}];
export function HomePage() {
  const [menuOpen, setMenuOpen] = useState(false);
  function closeMenu() {
    setMenuOpen(false);
  }
  return <div className="min-h-screen w-full bg-[#F8FAF9] pb-20 font-heading text-[#142843] md:pb-0" data-id="element-33">
      <header className="sticky top-0 z-40 border-b border-[#142843]/10 bg-[#F8FAF9]/95 backdrop-blur" data-id="element-34">
        <div className="mx-auto flex h-[76px] max-w-7xl items-center justify-between px-5 lg:px-8" data-id="element-35">
          <a href="#top" className="flex items-center gap-2" aria-label="Archetex Outdoor Design home" data-id="element-36">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-[#142843] text-lg font-bold text-[#359C9B]" data-id="element-37">
              A
            </span>
            <span className="leading-tight" data-id="element-38">
              <span className="block text-base font-bold tracking-tight" data-id="element-39">
                Archetex
              </span>
              <span className="block text-[11px] font-medium uppercase tracking-[0.12em] text-[#798C90]" data-id="element-40">
                Outdoor Design Co.
              </span>
            </span>
          </a>

          <nav className="hidden items-center gap-7 lg:flex" aria-label="Main navigation" data-id="element-41">
            {['Services', 'Projects', 'Reviews', 'Contact'].map(item => <a key={item} href={`#${item.toLowerCase()}`} className="text-sm font-semibold text-[#142843] transition hover:text-[#359C9B]" data-id="element-42">
                {item}
              </a>)}
          </nav>

          <a href="#estimate" className="hidden items-center gap-2 rounded-lg bg-[#359C9B] px-4 py-2.5 text-sm font-bold text-white transition hover:bg-[#2a8584] lg:flex" data-id="element-43">
            <Phone className="h-4 w-4" aria-hidden="true" data-id="element-44" /> Get an estimate
          </a>
          <button className="rounded-lg p-2 text-[#142843] lg:hidden" onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle navigation" aria-expanded={menuOpen} data-id="element-45">
            {menuOpen ? <X data-id="element-46" /> : <Menu data-id="element-47" />}
          </button>
        </div>
        {menuOpen && <nav className="border-t border-[#142843]/10 bg-[#F8FAF9] px-5 py-4 lg:hidden" aria-label="Mobile navigation" data-id="element-48">
            {['Services', 'Projects', 'Reviews', 'Contact'].map(item => <a key={item} onClick={closeMenu} href={`#${item.toLowerCase()}`} className="block border-b border-[#142843]/10 py-3 text-sm font-semibold" data-id="element-49">
                {item}
              </a>)}
            <a onClick={closeMenu} href="#estimate" className="mt-3 block rounded-lg bg-[#359C9B] px-4 py-3 text-center text-sm font-bold text-white" data-id="element-50">
              Get an estimate
            </a>
          </nav>}
      </header>

      <main id="top" data-id="element-51">
        <section className="px-0 pb-16 pt-0 lg:pb-24" data-id="element-52">
          <div className="relative min-h-[620px] overflow-hidden bg-[#142843] sm:min-h-[680px]" data-id="element-53">
            <img src="https://cdn.magicpatterns.com/uploads/5aSNGLDgTDfreuvgUNdg5v/archetex2.jpg" alt="Covered outdoor patio completed by Archetex Outdoor Design" className="absolute inset-0 h-full w-full object-cover" data-id="element-54" />
            <div className="absolute inset-0 bg-[#142843]/80" data-id="element-55" />
            <div className="relative mx-auto flex min-h-[620px] max-w-7xl items-center px-5 py-20 sm:min-h-[680px] lg:px-8" data-id="element-56">
              <div className="max-w-3xl text-white" data-id="element-57">
                <div className="mb-7 inline-flex w-fit items-center gap-2 rounded-full border border-white/35 bg-white/10 px-4 py-2 text-xs font-bold tracking-wide text-white shadow-[0_2px_10px_rgba(0,0,0,0.35)]" data-id="element-58">
                  <MapPin className="h-3.5 w-3.5 text-[#72d1cf]" aria-hidden="true" data-id="element-59" />
                  Serving Texarkana &amp; surrounding towns
                </div>
                <h1 className="text-5xl font-semibold leading-[0.96] tracking-[-0.06em] [text-shadow:0_3px_18px_rgba(0,0,0,0.6)] sm:text-6xl lg:text-8xl" data-id="element-60">
                  Outdoor living
                  <br data-id="element-61" />
                  and landscape
                  <br data-id="element-62" />
                  that’s{' '}
                  <span className="italic text-[#72d1cf]" data-id="element-63">built to last.</span>
                </h1>
                <p className="mt-7 max-w-xl text-lg leading-8 text-white/90 [text-shadow:0_2px_10px_rgba(0,0,0,0.55)] sm:text-xl" data-id="element-64">
                  Custom fencing, automatic gates, and complete backyard
                  transformations—owner-led from first sketch to final detail.
                </p>
                <div className="mt-9 flex flex-wrap gap-3" data-id="element-65">
                  <a href="#estimate" className="inline-flex items-center gap-2 rounded-lg bg-[#359C9B] px-6 py-4 text-sm font-bold text-white transition hover:bg-[#2a8584]" data-id="element-66">
                    Start your project{' '}
                    <ArrowRight className="h-4 w-4" aria-hidden="true" data-id="element-67" />
                  </a>
                  <a href={phoneHref} className="inline-flex items-center gap-2 rounded-lg border border-white/40 bg-white/10 px-6 py-4 text-sm font-bold text-white transition hover:border-white hover:bg-white/20" data-id="element-68">
                    <Phone className="h-4 w-4 text-[#72d1cf]" aria-hidden="true" data-id="element-69" />
                    Call (430) 318-6275
                  </a>
                </div>
                <div className="mt-11 flex items-center gap-3 text-sm text-white/90" data-id="element-70">
                  <div className="flex -space-x-1" data-id="element-71">
                    {[1, 2, 3, 4, 5].map(star => <Star key={star} className="h-4 w-4 fill-[#72d1cf] text-[#72d1cf]" aria-hidden="true" data-id="element-72" />)}
                  </div>
                  <span className="font-semibold" data-id="element-73">
                    Verified 5.0 Google business profile
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="services" className="border-y border-[#142843]/10 bg-white py-20 lg:py-28" data-id="element-74">
          <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-75">
            <div className="max-w-2xl" data-id="element-76">
              <p className="text-sm font-bold uppercase tracking-[0.18em] text-[#359C9B]" data-id="element-77">
                How we can help
              </p>
              <h2 className="mt-3 text-4xl font-semibold tracking-[-0.045em] sm:text-5xl" data-id="element-78">
                One team for the spaces around your home.
              </h2>
            </div>
            <div className="mt-12 grid gap-5 sm:grid-cols-2" data-id="element-79">
              {services.map(service => {
              const Icon = service.icon;
              return <article key={service.title} className="group overflow-hidden rounded-2xl border border-[#142843]/10 bg-[#F8FAF9]" data-id="element-80">
                    <div className="h-48 overflow-hidden" data-id="element-81">
                      <img src={service.image} alt="" className="h-full w-full object-cover transition duration-500 group-hover:scale-105" data-id="element-82" />
                    </div>
                    <div className="p-6" data-id="element-83">
                      <div className="mb-5 flex h-9 w-9 items-center justify-center rounded-lg bg-[#359C9B]/15 text-[#287c7b]" data-id="element-84">
                        <Icon className="h-5 w-5" aria-hidden="true" data-id="element-85" />
                      </div>
                      <h3 className="text-xl font-bold" data-id="element-86">{service.title}</h3>
                      <p className="mt-2 max-w-md leading-6 text-[#52636b]" data-id="element-87">
                        {service.description}
                      </p>
                    </div>
                  </article>;
            })}
            </div>

            <div className="mt-12 border-t border-[#142843]/10 pt-10" data-id="element-88">
              <p className="text-sm font-bold uppercase tracking-[0.18em] text-[#359C9B]" data-id="element-89">
                More ways we can help
              </p>
              <h3 className="mt-3 text-2xl font-semibold tracking-[-0.03em] text-[#142843] sm:text-3xl" data-id="element-90">
                More ways to bring your outdoor space together.
              </h3>
              <div className="mt-7 grid gap-px overflow-hidden rounded-xl border border-[#142843]/10 bg-[#142843]/10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-91">
                {additionalServices.map(service => <div key={service} className="flex items-center gap-3 bg-white px-4 py-4 text-sm font-semibold text-[#142843]" data-id="element-92">
                    <Check className="h-4 w-4 shrink-0 text-[#359C9B]" aria-hidden="true" data-id="element-93" />
                    {service}
                  </div>)}
              </div>
            </div>
          </div>
        </section>

        <section id="projects" className="py-20 lg:py-28" data-id="element-94">
          <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-95">
            <div className="flex flex-col justify-between gap-5 sm:flex-row sm:items-end" data-id="element-96">
              <div data-id="element-97">
                <p className="text-sm font-bold uppercase tracking-[0.18em] text-[#359C9B]" data-id="element-98">
                  Recent work
                </p>
                <h2 className="mt-3 text-4xl font-semibold tracking-[-0.045em] sm:text-5xl" data-id="element-99">
                  Made for the way you live outside.
                </h2>
              </div>
              <p className="max-w-sm text-sm leading-6 text-[#52636b]" data-id="element-100">
                From a secure entry to a finished backyard, each project starts
                with what matters most to you.
              </p>
            </div>
            <div className="mt-12 grid auto-rows-[220px] gap-4 md:grid-cols-4" data-id="element-101">
              {projects.map(project => <figure key={project.label} className={`group relative overflow-hidden rounded-xl bg-[#142843] ${project.className}`} data-id="element-102">
                  <img src={project.src} alt={project.label} className="h-full w-full object-cover transition duration-500 group-hover:scale-105" data-id="element-103" />
                  <figcaption className="absolute bottom-0 left-0 right-0 bg-[#142843]/85 px-4 py-3 text-sm font-bold text-white" data-id="element-104">
                    {project.label}
                  </figcaption>
                </figure>)}
            </div>
          </div>
        </section>

        <section id="reviews" className="bg-[#142843] py-20 text-white lg:py-28" data-id="element-105">
          <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-106">
            <p className="text-sm font-bold uppercase tracking-[0.18em] text-[#72d1cf]" data-id="element-107">
              From our customers
            </p>
            <div className="mt-3 flex flex-col justify-between gap-5 sm:flex-row sm:items-end" data-id="element-108">
              <h2 className="max-w-xl text-4xl font-semibold tracking-[-0.045em] sm:text-5xl" data-id="element-109">
                Built on details people remember.
              </h2>
              <a href={mapUrl} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-sm font-bold text-[#72d1cf] hover:text-white" data-id="element-110">
                View Google profile <ArrowRight className="h-4 w-4" data-id="element-111" />
              </a>
            </div>
            <div className="mt-12 grid gap-5 lg:grid-cols-3" data-id="element-112">
              {reviews.map(review => <Card key={review.name} className="border-white/10 bg-white/5 text-white shadow-none" data-id="element-113">
                  <CardContent className="p-6" data-id="element-114">
                    <Quote className="h-7 w-7 text-[#72d1cf]" aria-hidden="true" data-id="element-115" />
                    <p className="mt-5 text-sm leading-7 text-[#edf3f3]" data-id="element-116">
                      “{review.text}”
                    </p>
                    <p className="mt-6 text-sm font-bold text-white" data-id="element-117">
                      {review.name}
                    </p>
                  </CardContent>
                </Card>)}
            </div>
          </div>
        </section>

        <section id="contact" className="py-20 lg:py-28" data-id="element-118">
          <div className="mx-auto grid max-w-7xl gap-10 px-5 lg:grid-cols-[0.85fr_1.15fr] lg:px-8" data-id="element-119">
            <div className="lg:pt-10" data-id="element-120">
              <p className="text-sm font-bold uppercase tracking-[0.18em] text-[#359C9B]" data-id="element-121">
                Let’s talk
              </p>
              <h2 className="mt-3 text-4xl font-semibold tracking-[-0.045em] sm:text-5xl" data-id="element-122">
                Bring your outdoor ideas to the table.
              </h2>
              <p className="mt-6 max-w-md leading-7 text-[#52636b]" data-id="element-123">
                Tell us what you have in mind, and we’ll start with the details
                that make your space feel like yours.
              </p>
              <a href={phoneHref} className="mt-8 inline-flex items-center gap-3 text-lg font-bold text-[#142843] hover:text-[#359C9B]" data-id="element-124">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#359C9B] text-white" data-id="element-125">
                  <Phone className="h-4 w-4" data-id="element-126" />
                </span>{' '}
                (430) 318-6275
              </a>
              <div className="mt-10 flex gap-3" data-id="element-127">
                <a href={mapUrl} target="_blank" rel="noreferrer" className="flex h-10 w-10 items-center justify-center rounded-lg border border-[#142843]/15 text-[#142843] hover:border-[#359C9B] hover:text-[#359C9B]" aria-label="View Archetex on Google Maps" data-id="element-128">
                  <MapPin className="h-5 w-5" data-id="element-129" />
                </a>
                <a href={facebookUrl} target="_blank" rel="noreferrer" className="flex h-10 w-10 items-center justify-center rounded-lg border border-[#142843]/15 text-[#142843] hover:border-[#359C9B] hover:text-[#359C9B]" aria-label="View Archetex on Facebook" data-id="element-130">
                  <Facebook className="h-5 w-5" data-id="element-131" />
                </a>
              </div>
            </div>
            <Card id="estimate" className="border-[#142843]/10 bg-white shadow-[0_20px_50px_rgba(20,40,67,0.10)]" data-id="element-132">
              <CardContent className="p-6 sm:p-8" data-id="element-133">
                <h3 className="text-2xl font-bold tracking-[-0.03em]" data-id="element-134">
                  Request an estimate
                </h3>
                <p className="mt-2 text-sm leading-6 text-[#52636b]" data-id="element-135">
                  Share a few details about your project.
                </p>
                <div className="mt-7" data-id="element-136">
                  <EstimateForm data-id="element-137" />
                </div>
              </CardContent>
            </Card>
          </div>
        </section>
      </main>

      <footer className="border-t border-[#142843]/10 bg-white py-8 pb-24 md:pb-8" data-id="element-138">
        <div className="mx-auto flex max-w-7xl flex-col gap-4 px-5 text-sm text-[#52636b] sm:flex-row sm:items-center sm:justify-between lg:px-8" data-id="element-139">
          <p data-id="element-140">
            <span className="font-bold text-[#142843]" data-id="element-141">
              Archetex Outdoor Design Co.
            </span>{' '}
            · Texarkana &amp; surrounding towns
          </p>
          <p data-id="element-142">© {new Date().getFullYear()} Archetex Outdoor Design Co.</p>
        </div>
      </footer>

      <a href={phoneHref} className="fixed bottom-4 left-4 right-4 z-50 flex items-center justify-center gap-2 rounded-xl bg-[#359C9B] px-5 py-4 text-sm font-bold text-white shadow-xl md:hidden" data-id="element-143">
        <Phone className="h-4 w-4" aria-hidden="true" data-id="element-144" /> Call Now · (430)
        318-6275
      </a>
    </div>;
}